import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_STORAGE_ACCOUNTS_AZURE,
  GET_STORAGE_ACCOUNTS_AZURE_SUCCESS,
  GET_STORAGE_ACCOUNTS_AZURE_ERROR,
} from "./constant";

import { getAzureStorageAccountsApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureStorageAccountsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureStorageAccountsApi, params, provider);
    yield put({ type: GET_STORAGE_ACCOUNTS_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_STORAGE_ACCOUNTS_AZURE_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureStorageSaga() {
  yield takeLatest(GET_STORAGE_ACCOUNTS_AZURE, getAzureStorageAccountsList);
}
